module.exports = __webpack_public_path__ + "static/media/bg-core-quote-min.221328dc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/public/assets/images/agencyMonitor/bg-core-quote-min.jpeg
// module id = 992
// module chunks = 29